// extracted by mini-css-extract-plugin
export default {"container":"cart-widget_container__0nFpe","shoppingCart":"cart-widget_shoppingCart__LBtRE","productsCount":"cart-widget_productsCount__EWkeK"};